// extracted by mini-css-extract-plugin
export default {"chest":"Chest_chest__67Z61"};